import React from "react";
// import Home from "./Home";
import HomeLeft from "./HomeLeft";
import HomeRight from "./HomeRight";
import Countdown from "./Countdown";
import Innovate from "./Innovate";
import Inspire from "./Inspire";
import Impact from "./Impact";
import PastEvent from "./PastEvent";
import PastEventImages from "./PastEventImages";
import SponsorSlide from "./SponsorSlide";
import FloatingBalls from "../../components/Background/FloatingBalls";
import Aplic2027 from "./Aplic2027";
import Speech from "./Speech";
import Video from "./Video";
import Speaker from "./Speaker";
import Venue from "./Venue";
import Support from "./Support";
import Partner from "./Partner";
import "./index.scss"
import PromoPopup from "../../components/PromoPopup";

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page relative overflow-hidden">
       <PromoPopup />

      <div className="home-sec relative z-10">
        <div className="home-with-balls">
        <FloatingBalls />

        <div className="home-blended">
        <HomeLeft />
        </div>
        <div className=".home-right-fixed">
        <HomeRight />
        </div>
        <Countdown />
      
      </div>

     
    </div>

      <div className="inn-sec relative z-10">
        <div className="inn-with-balls">
        <Innovate />
        <Inspire />
        <Impact />
        </div>
      </div>

      <div>
        <PastEvent />
        <PastEventImages />
        <SponsorSlide />
        <Aplic2027 />
        <Speech />
        <Video/>
        <Speaker/>
        <Venue/>
        <Support />
        <Partner />
      </div>
    </div>
  );
};

export default LandingPage;
